import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./invoice.css";
import commaNumber from "comma-number";
let format = commaNumber.bindWith(",", ".");
const InvoiceBody = ({ purchaseData }) => {
  const classes = useStyles();
  // Invoice body

  /// end

  // console.log(purchase)
  let [purchase, purchaseSet] = useState([]);
  let [purchaseDetails, purchaseDetailsSet] = useState([]);

  useEffect(() => {
    purchaseSet(purchaseData);

    if (purchaseData.details != undefined) {
      purchaseDetailsSet(purchaseData.details);
    }
  }, [purchaseData]);



  return (
    <>
      <table className={"invoice-table"}>
        <thead>
          <tr>
            <td>SL</td>
            <td style={{ textAlign: "left" }}>Category</td>
            <td style={{ textAlign: "left" }}>Description</td>
            <td>Brand</td>
            <td>Country</td>
            <td>Unit</td>
            <td>Set No</td>
            <td>Set Qty</td>
            <td>Total Qty</td>
            <td>Due Qty</td>
            <td>Rate</td>
            <td>Total</td>
          </tr>
        </thead>
        <tbody>
          {purchaseDetails.map((detail, ind) => (
            <tr key={ind}>
              <td>{ind + parseFloat(1)}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_cat_name}</td>
              <td style={{ textAlign: "left" }}>{detail.prod_name}</td>
              <td>{detail.prod_brand_name}</td>
              <td>{detail.prod_color_name}</td>
              <td>{detail.prod_unit_name || "-"}</td>
              <td>{detail.prod_set_no || "-"}</td>
              <td>{detail.prod_set_qty || "-"}</td>
              <td>
                {format(parseFloat(detail.pur_total_qty || detail.prod_qty))}
              </td>
              <td>
                {format(parseFloat(detail.pur_due_qty || 0))}
              </td>
              <td>{format(parseFloat(detail.pur_rate).toFixed(2))}</td>
              <td style={{ textAlign: "right" }}>
                {format(parseFloat(detail.pur_total_amount).toFixed(2))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const useStyles = makeStyles((theme) => ({}));

export default InvoiceBody;
